module.exports = __webpack_public_path__ + "img/chart-area.a3199ab4.svg";